import { Dialog } from '@factorialco/f0-react/dist/experimental'
import { EyeVisible } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onConfirm: () => void
  onClose: () => void
}

const PublishToUseDialog = ({ onConfirm, onClose }: Props) => (
  <Dialog
    open
    onClose={onClose}
    header={{
      type: 'warning',
      title: i18n.t('forms.custom_templates.publish_to_use_dialog.title'),
      description: i18n.t('forms.custom_templates.publish_to_use_dialog.description'),
    }}
    actions={{
      primary: {
        icon: EyeVisible,
        label: i18n.t('forms.custom_templates.publish_to_use_dialog.confirm'),
        onClick: onConfirm,
      },
      secondary: {
        label: i18n.t('common.cancel'),
        onClick: onClose,
      },
    }}
  />
)

export default PublishToUseDialog
